import { getAxiosClient } from '../../http.client';
// @TODO: FLU-193 Handle this.
export const useSchedulingClient = () => {
    const client = async () => getAxiosClient("scheduling");
    const getInstallUrl = async () => {
        const api = await client();
        return (await api.get('/install')).data;
    };
    const getIntegration = async () => {
        const api = await client();
        return (await api.get('/integration')).data;
    };
    const disconnectIntegration = async () => {
        const api = await client();
        return (await api.delete(`/integration`)).data;
    };
    // Calls fluid-form availability endpoint using the user's natural language text
    const getAvailability = async (formKey, text) => {
        const api = await client();
        const body = { text };
        return (await api.post(`/${encodeURIComponent(formKey)}/availability`, body)).data;
    };
    const reserveSlot = async (params) => {
        const api = await client();
        const body = {
            start: typeof params.start === 'string' ? params.start : params.start.toISOString(),
            end: typeof params.end === 'string' ? params.end : params.end.toISOString(),
            guestDetails: params.guestDetails,
        };
        return (await api.post('/reserve', body)).data;
    };
    const getEvents = async (opts) => {
        const api = await client();
        const params = new URLSearchParams();
        if (opts?.startsAfter)
            params.set('startsAfter', opts.startsAfter);
        if (opts?.endsBefore)
            params.set('endsBefore', opts.endsBefore);
        if (typeof opts?.limit === 'number')
            params.set('limit', String(opts.limit));
        if (opts?.calendarId)
            params.set('calendarId', opts.calendarId);
        const qs = params.toString();
        return (await api.get(`/events${qs ? `?${qs}` : ''}`)).data;
    };
    const deleteEvent = async (eventId) => {
        const api = await client();
        return (await api.delete(`/events/${encodeURIComponent(eventId)}`)).data;
    };
    const getCalendars = async () => {
        const api = await client();
        return (await api.get('/calendars')).data;
    };
    const getGrant = async () => {
        const api = await client();
        return (await api.get('/grant')).data;
    };
    const makeRequestViaProxy = async (args) => {
        const api = await client();
        return (await api.post('/integration/proxy', { args })).data;
    };
    return {
        getInstallUrl,
        getIntegration,
        disconnectIntegration,
        getAvailability,
        reserveSlot,
        getEvents,
        deleteEvent,
        getCalendars,
        getGrant,
        makeRequestViaProxy,
    };
};
